(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$stickyStateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider) {
        $stateProvider
            .state('management-fixation', {
                parent: 'app',
                url: '/management/fixation',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.management.fixation.home.title',
                    title: 'Fixation Management'
                },
                views: {
                    'management-fixation@': {
                        templateUrl: 'app/entities/management/management-fixation.html',
                        controller: 'FixationManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
        $stickyStateProvider.enableDebug(true);
    }
})();
